var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { useMobxForm } from 'ziphy-web-shared/basic/lib/forms';
import { SignaturePad } from 'ziphy-web-shared/basic/lib/forms/fields';
import { Title, ToggleButton } from 'ziphy-web-shared/basic/lib/simple';
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $loader } from 'ziphy-web-shared/basic/utils';
import styles from '@nedoShared/modules/notes/ui/signModal/Sign.module.scss';
import { $legacyNotes as $notes } from '../LegacyNotes.store';
const SignModal = ({ addendumText, onAfterSubmit, _core }) => {
    const { t } = useTranslation();
    const isAddendum = Boolean(addendumText);
    const form = useMobxForm(useMemo(() => ({
        initialValues: {
            signature: '',
            addendumText,
            clientNotification: true,
        },
        fieldsConfig: {
            signature: { validate: ['required'] },
        },
    }), [addendumText]));
    const signature = form.field('signature', '');
    const clientNotification = form.field('clientNotification', true);
    const handleSubmit = form.submit((data) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield $notes.sign(data);
        if (!response.error) {
            if (typeof onAfterSubmit === 'function') {
                yield onAfterSubmit();
            }
            _core.onHide();
        }
    }));
    return (_jsxs(Modal, Object.assign({ size: 'lg', centered: true, scrollable: true }, { children: [_jsx("div", Object.assign({ className: "modal-toolbar" }, { children: _jsx(ModalToolbarBtn, { type: "close", action: () => _core.onHide(false) }) })), _jsx(Modal.Header, Object.assign({ className: 'pb-0' }, { children: t(isAddendum ? 'label.sign_addendum' : 'label.sign_notes') })), _jsxs(Modal.Body, { children: [_jsx("div", Object.assign({ className: styles.description }, { children: t('text.sign_notes.attestation_statement.cosigner') })), _jsxs("form", Object.assign({ id: form.id, onSubmit: $loader.registerHandler(form.id, handleSubmit) }, { children: [_jsx(Title, Object.assign({ size: 'h3', className: 'mb-10 mt-20' }, { children: t('label.signature') })), _jsx(SignaturePad, { field: signature, mode: ['secondary'] })] }))] }), _jsx(Modal.Footer, { children: _jsxs("div", Object.assign({ className: styles.buttons }, { children: [_jsx(Button, Object.assign({ mode: ['primary', 'sm'], form: form.id, isLoading: $loader.isRunHandler(form.id) }, { children: t(isAddendum ? 'btn.sign_addendum' : 'btn.sign_notes') })), _jsx(Button, Object.assign({ mode: ['secondary', 'sm', 'min110'], onClick: _core.onHide }, { children: t('btn.cancel') })), _jsx(ToggleButton, { mode: ['simple', 'sm'], selected: clientNotification.value, onClick: () => clientNotification.onChange(!clientNotification.value), invalid: clientNotification.isInvalid, label: t('text.sign_notes.patient_notification'), checkbox: { mode: 'circle' }, className: styles.clientNotification })] })) })] })));
};
SignModal.displayName = 'SignModal';
export default observer(SignModal);
